// We need jQuery
var $ = window.jQuery;

import calculateNights from './calculate-nights';
import setupTooltips from './enquiry-tooltips';
//import addPackageItemNotes from './enquiry-add-package-item-notes';
import updateTotal from './enquiry-update-total';

export default function() {
  var acf = window.acf;
  var $body = $('body');
  var addingAddonItem = null;
  acf.addFilter('select2_args/key=field_5ccc47a9a9fc5', function(args, $select, settings, field){
    args.ajax = false;
    return args;
  });
  acf.addFilter('select2_ajax_data/key=field_5ccc47a9a9fc5', function(data, args, $select, field){
    return false; // returning false aborts the request
  });
  // Addon Main Product
  acf.addFilter('select2_args', function(args, $select, settings, field){
    if(!field) {
      return args;
    }

    if(field.get('key') === 'field_69649d475d253') {
      args.ajax.transport = function (params, success, failure) {
        var results = getPackageProducts();
        if (params.data.s) {
          var term = params.data.s.toLowerCase();
          results = results.filter(function (item) {
            return item.text.toLowerCase().indexOf(term) > -1;
          });
        }
        success({
          results: results
        });
        return {
          abort: function () {}
        };
      };
    }

    return args;
  });
  function getPackageProducts(){
    var packageItemsRepeater = acf.getField('field_5c6c1967d0e0d');
    var results = [];
    if (packageItemsRepeater) {
      packageItemsRepeater.$rows().each(function() {
        var $row = $(this);
        if($row.hasClass('pi-is-addon')) {
          return 1;
        }
        var packageProductField = acf.getFields({
          key: 'field_5ccc47a9a9fc5',
          parent: $row,
          limit: 1
        });
        if (packageProductField && packageProductField.length > 0 && packageProductField[0].val()) {
          var $selectedOption = packageProductField[0].select2.$el.find('option:selected'); // Gets {id, text}

          if ($selectedOption) {
            results.push({
              id: $selectedOption.val(),
              text: $selectedOption.text()
            });
          }
        }
      });
    }
    return results;
  }

  function getSavedData($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row')
    var savedData;

    //core data
    savedData = {
      operatorID: parseInt($row.find('.operator select:enabled').select2('data')[0].id),
      productID: parseInt($row.find('.product select:enabled').select2('data')[0].id),
      operatorText: $row.find('.operator select:enabled').select2('data')[0].text,
      productText: $row.find('.product select:enabled').select2('data')[0].text,
      discount: $row.find('.item-discount input:enabled').val()
    }
    savedData.is_addon = false;
    savedData.is_addon_durational = true;
    if($row.hasClass('pi-is-addon')) {
      savedData.is_addon = true;
      savedData.is_standalone_addon = $row.hasClass('pi-is-standalone-addon');
      if(!savedData.is_standalone_addon) {
        savedData.main_product_id = parseInt($row.find('.addon-main-product select:enabled').select2('data')[0].id);
        savedData.main_product_text = $row.find('.addon-main-product select:enabled').select2('data')[0].text;
      }
      if ($row.find('.non-durational input[type="checkbox"]').prop("checked")) {
        savedData.is_addon_durational = false;
      }
    }

    let $tailorMadeCheckbox = ($row.find('.tailor-made input[type="checkbox"]'))

    if($tailorMadeCheckbox.is(':checked')) {
      savedData = $.extend(savedData, {
        standard: false,
        duration: parseInt($row.find('.standard-product .duration select:enabled').select2('data')[0].text),
        TMcountryID: parseInt($row.find('.standard-product .bespoke-countries select:enabled').select2('data')[0].id),
        TMcountryText: $row.find('.standard-product .bespoke-countries select:enabled').select2('data')[0].text,
      })
    } else {
      //saved normal product
      savedData = $.extend(savedData, {
        standard: true,
        duration: parseInt($row.find('.standard-product .duration select:enabled').select2('data')[0].text),
        seasonID: $row.find('.standard-product .season select:enabled').select2('data')[0].id,
        budgetID: $row.find('.standard-product .budget select:enabled').select2('data')[0].id,
        seasonText: ucwords($row.find('.standard-product .season select:enabled').select2('data')[0].text),
        budgetText: ucwords($row.find('.standard-product .budget select:enabled').select2('data')[0].text)
      });
    }

    var amendmentData = {
      savedPrices: {
        currency: $row.find('.supplier-price-currency input').val(),
        supplierLocal: $row.find('.supplier-price-local input').val(),
        customerPriceLocal: $row.find('.customer-price-local input').val(),
        supplierGBP: $row.find('.supplier-price-gbp input').val(),
        customerPricePreDiscountGBP: $row.find('.customer-price-pre-discount input').val(),
        specialOfferDiscountGBP: $row.find('.special-offer-discount input').val(),
        customerPriceGBP: $row.find('.customer-price-gbp input').val(),
        supplierMarginPerc: $row.find('.supplier-margin-perc input').val(),
        grossMarginLocal: $row.find('.gross-margin-local input').val(),
        grossMarginGBP: $row.find('.gross-margin input').val(),
        bookingFeePerc: $row.find('.booking-fee input').val(),
        bookingFeeGBP: $row.find('.booking-fee-gbp input').val(),
        bookingBonusPerc: $row.find('.booking-bonus input').val(),
        bookingBonusGBP: $row.find('.booking-bonus-gbp input').val(),
        grossMarginToSplitGBP: $row.find('.gross-margin-to-split-gbp input').val(),
        wtgSplitMarginGBP: $row.find('.wtg-split-margin-gbp input').val(),
        wtgPayoutGBP: $row.find('.wtg-payout input').val(),
        supplierDiscountOfferPerc: $row.find('.supplier-discount-offer input').val(),
        supplierDiscountOfferFixed: $row.find('.supplier-discount-offer-fixed input').val(),
        depositLocal: $row.find('.operator-deposit-amount-local input').val(),
        depositGBP: $row.find('.item-deposit input').val(),
        agentPayoutGBP: $row.find('.item-agent-payout input').val(),
        parentAgentPayoutGBP: $row.find('.item-parent-agent-payout input').val(),
      }
    }

    //amended by admin standard product
    if ($row.find('.admin-amended input[type="checkbox"]').is(":checked")) {
      amendmentData = $.extend(amendmentData, {
        amended: true
      })
    } else {
      amendmentData = $.extend(amendmentData, {
        amended: false
      })
    }

    savedData = $.extend(savedData, amendmentData)

    return savedData;
  }

  //the keys showItemPrice multiplies by qty when writing back to the fields
  var qtyScaledPriceKeys = ['supplierLocal', 'supplierGBP', 'customerPricePreDiscountGBP', 'specialOfferDiscountGBP', 'customerPriceGBP', 'grossMarginGBP', 'bookingFeeGBP', 'bookingBonusGBP', 'grossMarginToSplitGBP', 'wtgSplitMarginGBP', 'wtgPayoutGBP', 'depositGBP', 'agentPayoutGBP', 'parentAgentPayoutGBP'];

  function normalizeSavedPricesPerUnit(savedData, $row) {
    //amended field values are qty-multiplied totals; showItemPrice multiplies by qty
    //again on the next quantity change, so store them per-unit
    var qty = parseFloat($row.find('.num-pax input:enabled').val());

    if (!savedData.amended || !savedData.standard || isNaN(qty) || qty < 1) {
      return savedData;
    }

    qtyScaledPriceKeys.forEach(function (key) {
      var value = savedData.savedPrices[key];
      if (value !== '' && !isNaN(value)) {
        savedData.savedPrices[key] = (Number(value) / qty).toFixed(2);
      }
    });

    return savedData;
  }

  // Helpers
  function addLoading($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $el.first('.acf-fields').append('<div class="package-item-loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>');
  }

  function removeLoading($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $el.find('.package-item-loading').remove();
  }

  function addDateLinkTailorMade() {
    if(!($body.hasClass('approve-quote')) && $('#dates').length) {
      $('#tailor-made .start-date').find('.acf-input').after('<a class="copy-date" href="#">Copy main dates</a>')
    }

    $('#tailor-made').on('click', '.copy-date', function() {
      let startDate = $('#dates .start-date input.input').val()
      let endDate = $('#dates .end-date input.input').val()

      $('#tailor-made .start-date input').val(startDate)
      $('#tailor-made .end-date input').val(endDate)
    })
  }

  function addDateLinkPackageItem($el) {
    let $row = $el.closest('.acf-row')

    if(!$body.hasClass('approve-quote') && $('#dates').length){
      $row.find('.start-date .acf-input').after('<a class="copy-date" href="#">Copy main date</a>')

      $row.on('click', '.copy-date', function() {
        let startDate = $('#dates .start-date input.input').val()
        let endDate = $('#dates .end-date input.input').val()

        $row.find('.start-date input').val(startDate)
        $row.find('.end-date input').val(endDate)
      })
    }
  }

  function autoPopulateEndDate($el = null) {
    let $target

    if($el != null) {
      $target = $el.find('.start-date input.input')
    } else {
      $target = $('.start-date input.input')
    }

    $target.on('change', function(){
      let date = $(this).val()
      if($(this).closest('.acf-fields').find('.end-date input.input').val() == '') {
        $(this).closest('.acf-fields').find('.end-date input.input').val(date)
      }
    })
  }

  //Approve Quote
  function getApprovalNumbers($el, resultField, updatedApprovalValues) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');

    var productID = parseInt($row.find('.product select option:selected').val())

    var supplierPrice = parseFloat($el.closest('.hidden-fields').find('.supplier-price-local input:enabled').val()).toFixed(2)
    var customerPrice = parseFloat($el.closest('.hidden-fields').find('.customer-price-gbp input:enabled').val()).toFixed(2)

    if(resultField === 'supplier_price_local') {
      supplierPrice = updatedApprovalValues.supplierPriceLocal;
    }

    if(resultField === 'customer_price_gbp') {
      customerPrice = updatedApprovalValues.customerPriceGBP;
    }

    //check the admin amended boolean
    $row.find('.admin-amended input[type="checkbox"]').prop('checked', true)
    $row.find('.admin-amended input').val(1)

    addLoading($el);
    const params = new URLSearchParams(window.location.search);
    $.ajax({
      url: tofinoJS.ajaxUrl,
      type: 'POST',
      data: {
        action: 'getApprovalData',
        value: {
          supplierPrice: supplierPrice,
          customerPrice: customerPrice,
          productID: productID,
          enquiry_id: params.get('enquiry_id')
        }
      },
      dataType: 'json'
    })

    .done(function (response) {
      removeLoading($el);

      //convert response string values to Numbers
      for(let index in response) {
        if (!isNaN(response[index])) {
          response[index] = Number(response[index]);
        }
      }

      //write response to fields
      $row.find('.supplier-price-gbp input:enabled').val(response.supplierPriceGBP.toFixed(2))

      $row.find('.supplier-margin-perc input:enabled').val(parseFloat(updatedApprovalValues.supplierMarginPerc).toFixed(2))

      $row.find('.gross-margin input:enabled').val(response.grossMargin.toFixed(2))

      $row.find('.booking-fee input:enabled').val(response.bookingFeePerc.toFixed(2))
      $row.find('.booking-bonus input:enabled').val(response.bookingBonusPerc.toFixed(2))
      $row.find('.booking-fee-gbp input:enabled').val(response.bookingFeeGBP.toFixed(2))
      $row.find('.booking-bonus-gbp input:enabled').val(response.bookingBonusGBP.toFixed(2))

      $row.find('.gross-margin-to-split-gbp input:enabled').val(response.grossMarginToSplitGBP.toFixed(2))
      $row.find('.wtg-split-margin-gbp input:enabled').val(response.WTGSplitMarginGBP.toFixed(2))
      $row.find('.wtg-payout input:enabled').val(response.WTGPayoutGBP.toFixed(2))
      $row.find('.item-deposit input:enabled').val(response.depositGBP.toFixed(2))

      $row.find('.item-agent-payout input:enabled').val(response.agentPayout.toFixed(2))
      $row.find('.item-parent-agent-payout input:enabled').val(response.parentAgentPayout.toFixed(2))

      //also need to update data values that are used in addDiscountToItem
      $row.find('.item-price input:enabled').data('price', customerPrice)
      $row.find('.item-price input:enabled').val(customerPrice)

      $row.find('.item-agent-payout input:enabled').data('price', response.agentPayout.toFixed(2))
      $row.find('.item-parent-agent-payout input:enabled').data('price', response.parentAgentPayout.toFixed(2))

      if(resultField === 'supplier_price_local') {
        $row.find('.supplier-price-local input:enabled').val(supplierPrice)
      }

      if(resultField === 'customer_price_gbp') {
        $row.find('.customer-price-gbp input:enabled').val(customerPrice)
      }

      updateMaxDiscount($el)
      addDiscountToItem($el)

      updateTotal()
    })

    .fail(function (jqXHR, textStatus) {

    })
  }

  function updateApprovalItem($el) {
    let $updatedField = $el.closest('.acf-field')
    let $row = $el.closest('.acf-row')

    var productID = parseInt($row.find('.product select option:selected').val())

    var supplierPriceLocal = parseFloat($updatedField.find('input:enabled').val()).toFixed(2)
    var customerPriceGBP = parseFloat($updatedField.find('input:enabled').val()).toFixed(2)

    let supplierMarginPerc = parseFloat($row.find('.supplier-margin-perc input').val()).toFixed(2)

    const params = new URLSearchParams(window.location.search);
    //supplier price local field is updated
    if($updatedField.data('name') == 'supplier_price_local') {
      addLoading($el);

      $.ajax({
        url: tofinoJS.ajaxUrl,
        type: 'POST',
        data: {
          action: 'getApprovalCustomerPrice',
          value: {
            supplierPriceLocal: supplierPriceLocal,
            productID: productID,
            supplierMarginPerc: supplierMarginPerc,
            enquiry_id: params.get('enquiry_id')
          }
        },
        dataType: 'json'
      })

      .done(function (response) {
        removeLoading($el);
        getApprovalNumbers($el, 'customer_price_gbp', response)
      })
    }

    //customer price gbp field is updated
    if($updatedField.data('name') == 'customer_price_gbp') {

      //clone this customer price change to the main customer price field
      $row.find('.item-price input:enabled').val(customerPriceGBP)

      addLoading($el);
      const params = new URLSearchParams(window.location.search);
      $.ajax({
        url: tofinoJS.ajaxUrl,
        type: 'POST',
        data: {
          action: 'getApprovalSupplierPrice',
          value: {
            customerPriceGBP: customerPriceGBP,
            productID: productID,
            supplierMarginPerc: supplierMarginPerc,
            enquiry_id: params.get('enquiry_id')
          }
        },
        dataType: 'json'
      })

      .done(function (response) {
        removeLoading($el);
        getApprovalNumbers($el, 'supplier_price_local', response)
      })
    }
  }
  function updateExchangeRateDisplay($el) {
    var $row = !$el.hasClass('acf-row') ? $el.closest('.acf-row') : $el;
    var currency = $row.find('.supplier-price-currency-dd select').val();
    var rate = optionsJS.exchangeRates && optionsJS.exchangeRates[currency] ? optionsJS.exchangeRates[currency] : '';
    $row.find('.wtg-exchange-rate').html('(Exchange = ' + rate +')');
  }
  function updateTailorMadeProductApprovalItem($el) {
    var $row, productID, supplierMarginPerc, supplierDepositePerc, currency, supplierPrice, customerPrice, doRequest = false;
    $row = $el.closest('.acf-row');
    var priceCalcType = $row.find('.supplier-price-calc-type input:checked').val();
    currency = $row.find('.supplier-price-currency-dd select').val();

    if('customer' === priceCalcType) {
      supplierMarginPerc = parseFloat($row.find('.supplier-margin-perc input').val()).toFixed(2);
      customerPrice = $row.find('.customer-price-local input:enabled').val();
      supplierPrice = '';
      if(customerPrice) {
        customerPrice = parseFloat(customerPrice).toFixed(2);
        doRequest = true;
      }
    }else if('operator' === priceCalcType){
      supplierMarginPerc = parseFloat($row.find('.supplier-margin-perc input').val()).toFixed(2);
      supplierPrice = $row.find('.supplier-price-local input:enabled').val();
      customerPrice = '';
      if(supplierPrice) {
        supplierPrice = parseFloat(supplierPrice).toFixed(2);
        doRequest = true;
      }
    }else{
      supplierMarginPerc = '';
      customerPrice = $row.find('.customer-price-gbp input:enabled').val();
      supplierPrice = $row.find('.supplier-price-local input:enabled').val();
      if(customerPrice && supplierPrice) {
        customerPrice = parseFloat(customerPrice).toFixed(2);
        supplierPrice = parseFloat(supplierPrice).toFixed(2);
        doRequest = true;
      }
    }
    productID = parseInt($row.find('.product select option:selected').val());
    supplierDepositePerc = $row.find('.supplier-deposit-perc input').val();
    if(supplierDepositePerc) {
      parseFloat(supplierDepositePerc).toFixed(2);
    }else{
      supplierDepositePerc = 0;
    }

    const params = new URLSearchParams(window.location.search);

    //supplier price local field is updated
    if(doRequest) {
      addLoading($el);
      $.ajax({
        url: tofinoJS.ajaxUrl,
        type: 'POST',
        data: {
          action: 'getApprovalTailorMadePrices',
          value: {
            currency: currency,
            price_calc_type: priceCalcType,
            customer_price: customerPrice,
            supplier_price: supplierPrice,
            supplier_margin_perc: supplierMarginPerc,
            supplier_deposite_perc: supplierDepositePerc,
            enquiry_id: params.get('enquiry_id'),
            product_id: productID,
          }
        },
        dataType: 'json'
      })

      .done(function (response) {
        removeLoading($el);
        //convert response string values to Numbers
        for(let index in response.prices) {
          if (!isNaN(response.prices[index])) {
            response.prices[index] = Number(response.prices[index]);
          }
        }
        //check the admin amended boolean
        $row.find('.admin-amended input[type="checkbox"]').prop('checked', true);
        $row.find('.admin-amended input').val(1);
        //write response to fields currencyName
        $row.find('.supplier-price-currency input:enabled').val(response.currencyName);
        //$row.find('.wtg-exchange-rate').html('(Exchange = ' + response.exchange +')');

        $row.find('.supplier-price-local input:enabled').val(response.prices.supplierPriceLocal.toFixed(2))
        $row.find('.customer-price-local input:enabled').val(response.prices.customerPriceLocal.toFixed(2));

        $row.find('.supplier-price-gbp input:enabled').val(response.prices.supplierPriceGBP.toFixed(2))
        $row.find('.customer-price-gbp input:enabled').val(response.prices.customerPriceGBP.toFixed(2));

        $row.find('.supplier-margin-perc input:enabled').val(response.prices.supplierMarginPerc.toFixed(2))

        $row.find('.gross-margin input:enabled').val(response.prices.grossMarginGBP.toFixed(2))
        $row.find('.gross-margin-local input:enabled').val(response.prices.grossMarginLocal.toFixed(2));
        $row.find('.operator-deposit-amount-local input:enabled').val(response.prices.depositLocal.toFixed(2));
        $row.find('.operator-deposit-amount-gbp input:enabled').val(response.prices.depositGBP.toFixed(2));

        $row.find('.booking-fee input:enabled').val(response.prices.bookingFeePerc.toFixed(2))
        $row.find('.booking-bonus input:enabled').val(response.prices.bookingBonusPerc.toFixed(2))
        $row.find('.booking-fee-gbp input:enabled').val(response.prices.bookingFeeGBP.toFixed(2))
        $row.find('.booking-bonus-gbp input:enabled').val(response.prices.bookingBonusGBP.toFixed(2))

        $row.find('.gross-margin-to-split-gbp input:enabled').val(response.prices.grossMarginToSplitGBP.toFixed(2))
        $row.find('.wtg-split-margin-gbp input:enabled').val(response.prices.WTGSplitMarginGBP.toFixed(2))
        $row.find('.wtg-payout input:enabled').val(response.prices.WTGPayoutGBP.toFixed(2));
        $row.find('.item-deposit input:enabled').val(response.prices.depositGBP.toFixed(2));

        $row.find('.item-agent-payout input:enabled').val(response.prices.agentPayout.toFixed(2))
        $row.find('.item-parent-agent-payout input:enabled').val(response.prices.parentAgentPayout.toFixed(2))

        //also need to update data values that are used in addDiscountToItem
        $row.find('.item-price input:enabled').data('price', response.prices.customerPriceGBP)
        $row.find('.item-price input:enabled').val(response.prices.customerPriceGBP)

        $row.find('.item-agent-payout input:enabled').data('price', response.prices.agentPayout.toFixed(2))
        $row.find('.item-parent-agent-payout input:enabled').data('price', response.prices.parentAgentPayout.toFixed(2))

        updateMaxDiscount($el)
        addDiscountToItem($el)

        updateTotal()
      })
      .fail(function (jqXHR, textStatus) {

        removeLoading($el);
        alert('Failed try again');
      })
    }
  }

  function disableMainFields() {
    // set properties to false to "disabled" fields but still save values
    $('#nights input:enabled').prop('readonly', true);
    $('#subtotal-price input:enabled').prop('readonly', true);
    $('#total-agent-payout-pre-discount input:enabled').prop('readonly', true);
    $('#total-agent-payout input:enabled').prop('readonly', true);
    $('#total-price input:enabled').prop('readonly', true);
    $('#total-deposit input:enabled').prop('readonly', true);

    if($body.hasClass('approve-quote')) {
      //disable all totals
      $('#totals input:enabled').prop('readonly', true)
    }

    if(!$body.hasClass('user-role-wtg') && !$body.hasClass('add-enquiry') ) {
      $('#tailor-made .tailor-made-id-details textarea').prop('readonly', true);
    }
  }

  function disableItemFields($el) {
    let $row = $el.closest('.acf-row')

    $row.find('.hidden-fields input:enabled').prop('readonly', true);

    $row.find('.item-deposit input:enabled').prop('readonly', true);
    $row.find('.package-item-price input:enabled').prop('readonly', true);

    // EXCEPT
    $row.find('.admin-amended input:enabled').prop('readonly', false)
    $row.find('.tailor-made input:enabled').prop('readonly', false)

    if($body.hasClass('approve-quote')) {
      //APPROVE ENQUIRY
      //Disable item discount
      $row.find('.item-discount input:enabled').prop('readonly', true)

      //hidden field group
      $row.find('.supplier-price-local input:enabled').prop('readonly', false)
      $row.find('.customer-price-gbp input:enabled').prop('readonly', false)
    }
  }

  function disableFlightFields($el) {
    let $row = $el.closest('.acf-row')

    if($body.hasClass('approve-quote')) {
      $row.find('input:enabled').prop('readonly', true)
    } else {
      $row.find('.flight-total input:enabled').prop('readonly', true);
      $row.find('.flight-total-apc input:enabled').prop('readonly', true);
      $row.find('.flight-total-apc-real input:enabled').prop('readonly', true);
    }
  }

  function disableBookingFields() {
    $('.hidden-fields input:enabled').not('input[type="radio"], input[type="checkbox"]').prop('readonly', true);
    $('.item-discount input:enabled').prop('readonly', true);
    $('.package-item-price input:enabled').prop('readonly', true);

    //flight items
    $('.flight-price input:enabled').prop('readonly', true);
    $('.flight-tax input:enabled').prop('readonly', true);
  }
  function hideItemBespokeFields($row) {
    $row.find('.supplier-price-currency').removeClass('d-none');
    $row.find('.special-offer-discount').removeClass('d-none');
    $row.find('.supplier-discount-offer').removeClass('d-none');
    $row.find('.supplier-discount-offer-fixed').removeClass('d-none');
    $row.find('.customer-price-pre-discount').removeClass('d-none');
    $row.find('.bespoke-countries').addClass('d-none');
    $row.find('.supplier-price-currency-dd').addClass('d-none');
    $row.find('.supplier-price-calc-type, .customer-price-local, .supplier-deposit-perc').addClass('d-none');
    $row.find('.supplier-margin-perc input, .supplier-deposit-perc input').prop('readonly', true);
    $row.find('.customer-price-gbp input').prop('readonly', false);
    $row.find('.num-pax input').prop('readonly', false);
  }
  function showItemBespokeFields($row) {
    var priceCalcType = $row.find('.supplier-price-calc-type input:checked').val();
    if('customer' === priceCalcType) {
      $row.find('.customer-price-local input').prop('readonly', false);
      $row.find('.supplier-price-local input').prop('readonly', true);
      $row.find('.supplier-margin-perc input').prop('readonly', false);
    }else if('operator' === priceCalcType){
      $row.find('.supplier-price-local input').prop('readonly', false);
      $row.find('.customer-price-local input').prop('readonly', true);
      $row.find('.supplier-margin-perc input').prop('readonly', false);
    }else{
      //manual: operator supplies both prices. Customer price is entered in GBP,
      //matching the radio-change handler and updateTailorMadeProductApprovalItem
      $row.find('.supplier-price-local input').prop('readonly', false);
      $row.find('.customer-price-local input').prop('readonly', true);
      $row.find('.supplier-margin-perc input').prop('readonly', true);
    }
    $row.find('.supplier-price-currency').addClass('d-none');
    $row.find('.special-offer-discount').addClass('d-none');
    $row.find('.supplier-discount-offer').addClass('d-none');
    $row.find('.supplier-discount-offer-fixed').addClass('d-none');
    $row.find('.customer-price-pre-discount').addClass('d-none');
    $row.find('.bespoke-countries').removeClass('d-none');
    $row.find('.supplier-price-currency-dd').removeClass('d-none');
    $row.find('.supplier-price-calc-type, .supplier-price-local, .customer-price-local, .supplier-deposit-perc').removeClass('d-none');
    $row.find('.supplier-deposit-perc input').prop('readonly', false);
    $row.find('.customer-price-gbp input').prop('readonly', 'customer' === priceCalcType || 'operator' === priceCalcType);
    //$row.find('.num-pax input').val(1).prop('readonly', true);
  }
  function clearTailorMadeDerivedFields($row) {
    //blank calculated values so stale figures cannot survive a calc-type switch
    $row.find('.gross-margin input, .gross-margin-local input, .wtg-payout input, .booking-fee-gbp input, .booking-bonus-gbp input, .gross-margin-to-split-gbp input, .wtg-split-margin-gbp input, .operator-deposit-amount-local input, .operator-deposit-amount-gbp input, .item-deposit input').val('');
    $row.find('.item-price input, .item-agent-payout input, .item-parent-agent-payout input').val('').data('price', '');
  }
  function showHideItemBespokeFields($row) {
    let productID = getProductID($row);
    let product = JSON.parse(localStorage.getItem('product-' + productID));
    if(product && !product.standard && product.tailor_made) {
      showItemBespokeFields($row);
    }else{
      hideItemBespokeFields($row);
    }

  }
  function showHideItemBookingTailorMadefields($row, isTM) {
    if(isTM) {
      $row.find('.season, .budget').hide();
      $row.find('.supplier-price-currency').addClass('d-none');
      $row.find('.special-offer-discount').addClass('d-none');
      $row.find('.supplier-discount-offer').addClass('d-none');
      $row.find('.supplier-discount-offer-fixed').addClass('d-none');
      $row.find('.customer-price-pre-discount').addClass('d-none');
      $row.find('.bespoke-countries').removeClass('d-none');
      $row.find('.supplier-price-currency-dd').removeClass('d-none');
      $row.find('.supplier-price-calc-type, .supplier-price-local, .customer-price-local, .supplier-deposit-perc').removeClass('d-none');
    }else{
      $row.find('.supplier-price-currency').removeClass('d-none');
      $row.find('.special-offer-discount').removeClass('d-none');
      $row.find('.supplier-discount-offer').removeClass('d-none');
      $row.find('.supplier-discount-offer-fixed').removeClass('d-none');
      $row.find('.customer-price-pre-discount').removeClass('d-none');
      $row.find('.bespoke-countries').addClass('d-none');
      $row.find('.supplier-price-currency-dd').addClass('d-none');
      $row.find('.supplier-price-calc-type, .customer-price-local, .supplier-deposit-perc').addClass('d-none');
    }
  }

  function calculateNightsForItem($row) {
    var nights = 0;
    var dateStart = $row.find('.start-date input.input').val();
    var dateEnd = $row.find('.end-date input.input').val();
    dateStart = dateStart.replace(/-/g, ' ');
    dateEnd = dateEnd.replace(/-/g, ' ');
    if (dateStart && dateEnd) {
      dateStart = Date.parse(dateStart);
      dateEnd = Date.parse(dateEnd);
      nights = Math.round((dateEnd - dateStart) / 1000 / 60 / 60 / 24);
    }
    return Math.max(0, nights);
  }

  function monitorIncludeFlightButton() {
    $('#include-flight-in-deposit').find('input[type="checkbox"]').on('change', function() {
      //wait for the acf classes to be added. there's probably a better way of doing this
      setTimeout(function(){
        updateTotal()
      }, 500)
    })
  }

  function getProductTitle($el) {
    var $product;
    if($el.hasClass('.acf-row')) {
      $product = $el.find('.standard-product .product select:enabled')
    }else{
      $product = $el.closest('.acf-row').find('.standard-product .product select:enabled')
    }


    if($product.select2('data').length > 0) {
      return $product.select2('data')[0].text;
    }
    return '';
  }
  function getProductID($el) {
    var $product;
    if($el.hasClass('.acf-row')) {
      $product = $el.find('.standard-product .product select:enabled')
    }else{
      $product = $el.closest('.acf-row').find('.standard-product .product select:enabled')
    }


    if($product.select2('data').length > 0) {
      return $product.select2('data')[0].id
    }
  }

  function getQty($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    return $el.find('.num-pax input:enabled').val();
  }

  function getDuration($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    return $el.find('.standard-product .duration select:enabled').select2('data')[0].text;
  }

  function getBudget($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    return $el.find('.standard-product .budget select:enabled').select2('data')[0].id;
  }

  function getSeason($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    return $el.find('.standard-product .season select:enabled').select2('data')[0].id;
  }

  function clearPrices($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $row.find('.hidden-fields input').not('input[type="radio"], input[type="checkbox"]').val('');
    $row.find('.package-item-price input').val('');
  }

  function ucwords(lower) {
    return lower.replace(/\w\S*/g, function (word) {
      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
  }

  function updateFlightTotal($el) {
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');

    var flightPrice = Number($row.find('.flight-price input:enabled').val());
    var flightTax = Number($row.find('.flight-tax input:enabled').val());
    var flightAssFee = Number($row.find('.flight-ass-fees input:enabled').val());
    var flightTPS = Number($row.find('.flight-tps input:enabled').val());

    var wtgAdminCharge = Number(optionsJS.wtgFlightAdmin);

    var apcPAX = Number($row.find('.num-pax input:enabled').val()) - Number($row.find('.num-pax-excluded input:enabled').val());
    var apcChargeTotal = Number(apcPAX * optionsJS.apc);

    $row.find('.flight-total-apc input:enabled').val(wtgAdminCharge.toFixed(2));
    $row.find('.flight-total-apc-real input:enabled').val(apcChargeTotal.toFixed(2));

    //add them up
    var pricePerPerson = flightPrice + flightTax + flightAssFee + flightTPS + wtgAdminCharge;

    if(Number.isInteger(flightPrice) && flightPrice > 0) {
      $row.find('.flight-total input:enabled').val(((pricePerPerson * $row.find('.num-pax input:enabled').val()) + apcChargeTotal).toFixed(2));
    }

    updateTotal();
  }

  function getProductOptions($el, operatorID, discount) {
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    addLoading($row);
    const params = new URLSearchParams(window.location.search);
    $.ajax({
      url: tofinoJS.ajaxUrl,
      type: 'POST',
      data: {
        action: 'getProductOptions',
        value: {
          operator_id: operatorID,
          enquiry_id: params.get('enquiry_id')
        }
      },
      dataType: 'json'
    })

    .done(function(response) {
      removeLoading($row);
      populateProducts($row, response);

      //discount needs re-adding if it's stored. not ideal
      $row.find('.item-discount input').val(discount);
      handlePackageItemLocking($row);
    })

    .fail(function (jqXHR, textStatus) {

    })
  }
  function getAddonProductOptions($row, productID, discount) {
    addLoading($row);
    const params = new URLSearchParams(window.location.search);
    $.ajax({
      url: tofinoJS.ajaxUrl,
      type: 'POST',
      data: {
        action: 'getProductOptions',
        value: {
          is_addon: true,
          main_product_id: productID,
          enquiry_id: params.get('enquiry_id')
        }
      },
      dataType: 'json'
    })

    .done(function(response) {
      removeLoading($row);
      populateProducts($row, response);

      //discount needs re-adding if it's stored. not ideal
      $row.find('.item-discount input').val(discount);
      handlePackageItemLocking($row);
    })

    .fail(function (jqXHR, textStatus) {

    })
  }

  function populateProducts($el, response) {
    var item;
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    var currentRow = $row.data('id');
    var data;
    var $productSelect = $row.find('.standard-product .product select');

    $productSelect.empty();
    $productSelect.select2('destroy');
    $productSelect.append('<option></option>');

    var output = [];
    //populate product options
    if (response.length > 0) {
      for (var i = 0; i < response.length; i++) {
        let showProduct = true;
        let postTitle = response[i].post_title

        if(!response[i].info.standard) {
          //All bespoke products
          if($body.hasClass('approve-quote')) {
            //only return bespoke products when admin approving quote
            postTitle = response[i].info.tailor_made ? ' ' + postTitle : 'BESPOKE | Comm.: ' + response[i].supplierMarginPerc + '% | ' + postTitle;
          } else {
            if(response[i].info.tailor_made) {

            }else if(response[i].info.da_salable) {
              //DA Saleable products
              postTitle = 'AD: ' + postTitle
            } else {
              if(!$row.find('.admin-amended input[type="checkbox"]').is(":checked")) {
                // don't add bespoke items unless they package item has been admin amended
                showProduct = false;
              }
            }
          }
        }

        if(response[i].marginDepositFixedVal) {
          postTitle + ' | FIXED DEPOSIT £' + response[i].marginDepositFixedVal + ' | ' + postTitle
        }

        if(response[i].pricing_unit === 'family_of_4') {
          postTitle = postTitle + ' [per family of 4]';
        }

        if(showProduct) {
          item = '<option value="' + response[i].ID + '">' + postTitle + '</option>'
          //$productSelect.append(item);

          output.push({
            id: response[i].ID,
            text: postTitle,
            tailorMade: response[i].info.tailor_made ? 1: 0
          });
        }
      }

    }

    output.sort((a, b) => a.text.localeCompare(b.text));
    output.sort((a, b) => {
      if( a.tailorMade > b.tailorMade) {
        return -1;
      }else if(a.tailorMade < b.tailorMade ) {
        return 1;
      }
      return 0;
    });

    for(i = 0; i < output.length; i++) {
      $productSelect.append('<option value="' + output[i].id + '">' + output[i].text + '</option>');
    }
    //Revert to saved if saved
    if (localStorage.getItem(currentRow) != null) {
      let savedData = JSON.parse(localStorage.getItem(currentRow))
      let storedProductID = savedData.productID;
      $productSelect.val(storedProductID);
    }
    $productSelect.attr('data-ajax', 0);
    acf.newSelect2($productSelect);

    for (i = 0; i < response.length; i++) {
      data = {
        pricing: {}
      };

      var pricing = response[i]['pricing'], key;

      //LEGACY CODE: would be better to work with the response instead of copying into data object

      data.ID = response[i]['ID'];
      data.opeator = response[i]['operator'];
      data.approval = response[i]['approval'];
      data.seasonal = response[i]['info']['seasonal'];
      data.link = response[i]['link'];
      data.bookingFeePerc = response[i]['bookingFeePerc'];
      data.supplierDiscountOffer = response[i]['supplierDiscountOffer'];
      data.supplierDiscountOfferFixed = response[i]['supplierDiscountOfferFixed'];
      data.currency = response[i]['currency'];
      data.countries = response[i]['countries'];
      data.standard = response[i]['info']['standard'];
      data.has_addon = response[i]['info']['has_addon'];
      data.is_addon = response[i]['info']['is_addon'];
      data.is_addon_durational = response[i]['info']['is_addon_durational'];

      data.deposit = response[i]['deposit'];
      data.marginDepositFixedVal = response[i]['marginDepositFixedVal'];

      if(!data.standard) {
        data.salable = response[i]['info']['da_salable'];
        data.tailor_made = response[i]['info']['tailor_made'];
      }

      if (!data.seasonal && pricing) {
        //build array from keyed data
        for (key in pricing) {
          data.pricing[key] = pricing[key];
        }

      } else if (data.seasonal && pricing) {
        // build array from keyed data
        for (key in pricing) {
          data.pricing[key] = {
            //LATER: Automate this using $.extend
            bookingBonus: pricing[key].bookingBonus,
            peak: {
              luxury: pricing[key].peak.luxury,
              comfort: pricing[key].peak.comfort,
              standard: pricing[key].peak.standard,
              budget: pricing[key].peak.budget,
            },
            high: {
              luxury: pricing[key].high.luxury,
              comfort: pricing[key].high.comfort,
              standard: pricing[key].high.standard,
              budget: pricing[key].high.budget,
            },
            shoulder: {
              luxury: pricing[key].shoulder.luxury,
              comfort: pricing[key].shoulder.comfort,
              standard: pricing[key].shoulder.standard,
              budget: pricing[key].shoulder.budget,
            },
            low: {
              luxury: pricing[key].low.luxury,
              comfort: pricing[key].low.comfort,
              standard: pricing[key].low.standard,
              budget: pricing[key].low.budget,
            }
          }
        }
      }

      localStorage.setItem('product-' + response[i]['ID'], JSON.stringify(data));
    }

    addProductLink($el);
    populateDurationOptions($el);
    //addPackageItemNotes($el);
    showHideItemBespokeFields($row);
  }

  function addProductLink($el) {
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    var productID = getProductID($row);
    var product = JSON.parse(localStorage.getItem('product-' + productID));
    var productTitle = getProductTitle($row);
    if(product != null) {
      var link = product.link;
      $row.find('.standard-product .product .more-info').remove();
      $row.find('.standard-product .product .add-addon-package-item').remove();
      if(product.has_addon) {
        $row.find('.standard-product .product .acf-label').append('<a class="add-addon-package-item" href="#" data-pid="' + productID + '" data-title="' + productTitle + '">Include Add-On</a>');
      }
      if(product.standard) {
        $row.find('.standard-product .product .acf-label').append('<a class="more-info" target="_blank" href="' + link + '">Product detail</a>');
      }
    }
  }
  function handlePackageItemApproveField($row){
    var $el = $row.find('.pi-approve-item');
    var productID = getProductID($el);
    var product = JSON.parse(localStorage.getItem('product-' + productID));

    if(product && !product.approval) {
      $row.find('.pi-approve-item input[type="checkbox"]').prop('checked', true);
      $row.find('.pi-approve-item input').val(1);
    }else{
      $row.find('.pi-approve-item input[type="checkbox"]').prop('checked', false);
      $row.find('.pi-approve-item input').val(0);
    }
  }
  function highlightApprovalProduct($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    var productID = getProductID($el);
    var product = JSON.parse(localStorage.getItem('product-' + productID));

    //clear previous alerts
    $row.find('.standard-product .approval-needed').remove();

    if(product != null) {
      //reset these fields
      $row.find('.supplier-price-local input:enabled').prop('readonly', false)
      if(!product.tailor_made){
        $row.find('.customer-price-gbp input:enabled').prop('readonly', false)
      }

      if (product.approval) {
        //PRODUCT REQUIRES APPROVAL
        if(!$body.hasClass('approve-quote')) {
          //REGULAR ENQUIRY FORM
          if ($row.find('.admin-amended input[type="checkbox"]').is(":checked")) {
            //TODO: ENSURE ADMIN AMENDED AND FULL QUOTE APPROVED
            $row.find('.standard-product').prepend('<div class="approval-needed alert alert-success"><p>This product has now been amended by the reservations team. If you make any further amendments, re-approval will be required.</p></div>');
          } else {
            $row.find('.standard-product').prepend('<div class="approval-needed alert alert-danger"><p>The item you have selected requires approval. On saving the quote, the operator will be notified.</p><p>If necessary, make sure to upload any required participant documents and use the \'<strong>Add Package Note</strong>\' field to include any particular requests you want to inform the operator, unless you\'ve used the ‘<strong>Tailor Made Request</strong>’ option above. Do this before saving the quote.</p><p>Once approved, you will be emailed. You’ll then be able to apply any discount or mark-up and inform your client the trip is ready to book and payment can be taken.</p></div>');

            //set admin approved back to false
            const params = new URLSearchParams(window.location.search)

            $.ajax({
              url: tofinoJS.ajaxUrl,
              type: 'POST',
              data: {
                action: 'setAdminUnapproved',
                value: {
                  enquiry_id: params.get('enquiry_id')
                }
              },
              dataType: 'json'
            })

            .done(function (response) {

            })

            .fail(function (jqXHR, textStatus) {

            })

            $row.find('.item-discount input:enabled').prop('readonly', true)
          }
        } else {
          //APPROVAL FORM
          $row.find('.standard-product').prepend('<div class="approval-needed alert alert-danger"><p>This product is flagged as requiring approval.</p></div>');
        }
      } else if (!product.standard) {
        //BESPOKE PRODUCT && Tailor made product
        $row.find('.item-discount input:enabled').prop('readonly', false)

        if(!product.salable) {
          if(!$body.hasClass('approve-quote')) {
            $row.find('.standard-product').prepend('<div class="approval-needed alert alert-info"><p>This is a Tailor Made product and cannot be modified.</p></div>');
          } else {
            $row.find('.standard-product').prepend('<div class="approval-needed alert alert-info"><p>This is a Tailor Made product.</p></div>');
          }
        }

        updateMaxDiscount($el);
      } else {
        //DOESNT REQUIRE APPROVAL AND ISNT BESPOKE

        if(!$body.hasClass('approve-quote')) {
          //REGULAR ENQUIRY
          $row.find('.item-discount input:enabled').prop('readonly', false)
        } else {
          //APPROVAL FORM
          $row.find('.standard-product').prepend('<div class="approval-needed alert alert-success"><p>This product does not require approval.</p></div>');

          $row.find('.supplier-price-local input:enabled').prop('readonly', true)
          $row.find('.customer-price-gbp input:enabled').prop('readonly', true);
        }
      }
    }
  }

  function populateDurationOptions($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    let productID = getProductID($el);
    let product = JSON.parse(localStorage.getItem('product-' + productID));
    let rowCountries = [];
    let isAddonItem = $row.hasClass('pi-is-addon');
    let isStandaloneAddon = $row.hasClass('pi-is-standalone-addon');

    if(product !== null) {
      rowCountries = product.countries ? product.countries : '';
      $row.attr('class', 'acf-row acf-package-item-row');
      if(isAddonItem) {
        $row.addClass('pi-is-addon');
      }
      if(isStandaloneAddon) {
        $row.addClass('pi-is-standalone-addon');
      }
      if(!product.standard && product.tailor_made && $row.find('.bespoke-countries select').val()) {
        rowCountries = [$row.find('.bespoke-countries select').val()];
      }
      rowCountries.forEach(function(cid) {
        $row.addClass('row-country-' + cid);
      });
      if(product.standard && product.approval) {
        // Needs reservation team approval
        $row.addClass('row-needs-reservation-approval');
      }

      //add product type class to acf-row
      if(product.standard) {
        $row.addClass('standard');

        $row.find('.tailor-made input[type="checkbox"]').prop('checked', false);
        $row.find('.tailor-made input').val(0);
      }else if(!product.standard && product.tailor_made) {
        //load the bespoke values into field data properties
        let itemPrice = $row.find('.item-price input:enabled').val();
        let itemAgentPayout = $row.find('.item-agent-payout input:enabled').val();

        $row.addClass('row-tailor-made');
        $row.find('.tailor-made input[type="checkbox"]').prop('checked', true);
        $row.find('.tailor-made input').val(1);
        $row.find('.item-price input:enabled').data('price', itemPrice)
        $row.find('.item-agent-payout input:enabled').data('price', itemAgentPayout);
      } else if(!product.standard && product.salable) {
        //AD product
        $row.addClass('bespoke da-salable');

        $row.find('.customer-price-gbp input:enabled').prop('readonly', false)
      } else {
        //bespoke product
        $row.addClass('bespoke');

        $row.find('.tailor-made input[type="checkbox"]').prop('checked', true)
        $row.find('.tailor-made input').val(1)

        //load the bespoke values into field data properties
        let itemPrice = $row.find('.item-price input:enabled').val()
        let itemAgentPayout = $row.find('.item-agent-payout input:enabled').val();

        $row.find('.item-price input:enabled').data('price', itemPrice)
        $row.find('.item-agent-payout input:enabled').data('price', itemAgentPayout)
      }

      var currentRow = $row.data('id');
      var $durationSelect = $row.find('.standard-product .duration select:enabled');

      //clear all the prices if we're not loading a saved product
      if (localStorage.getItem(currentRow) === null) {
        clearPrices($el)
      }

      var output = [];

      if(product.standard) {
        $durationSelect.find('option').remove();
        if($durationSelect.select2('data')[0] != null){
          $durationSelect.select2('destroy');
        }

        //LATER: Check validity of duration intervals
        if(product.is_addon && !product.is_addon_durational) {
          $row.addClass('pi-addon-non-durational');
          hideSeasonArea($row);
          showItemPrice($row);
        }else{
          $row.removeClass('pi-addon-non-durational');
          for (var key in product.pricing) {
            var item = '<option value="' + key + '">' + key + '</option>';
            $durationSelect.append(item);

            output.push({
              'id': parseInt(key),
              'text': key
            });
          }
          if (localStorage.getItem(currentRow) != null) {
            var storedDuration = JSON.parse(localStorage.getItem(currentRow)).duration;
            $durationSelect.val(storedDuration);
          }

          showDurationArea($row);
          $durationSelect.select2({
            query: function (query) {
              //do ajax call which retrieves the results array in this format:
              var data = {
                results: output
              };
              //pass it to the query callback inside your Ajax callback:
              query.callback(data);
            }
          });

          if ($durationSelect.select2('data')[0] != null) {
            if (product.seasonal) {
              populateSeasonOptions($el);
            } else {
              hideSeasonArea($el);
              showItemPrice($el);
            }
          }
        }
      }else if(product.tailor_made) {
        // This is a tailor made
        $durationSelect.find('option').remove();
        $durationSelect.select2('destroy');
        var tailor_made_nights = calculateNightsForItem($row);
        output.push({
          'id': tailor_made_nights,
          'text': tailor_made_nights,
        });
        $durationSelect.append('<option value="'+ tailor_made_nights +'" selected="selected">' + tailor_made_nights + '</option>');


        $durationSelect.select2({
          query: function (query) {
            //do ajax call which retrieves the results array in this format:
            var data = {
              results: output
            };
            //pass it to the query callback inside your Ajax callback:
            query.callback(data);
          }
        });

        hideSeasonArea($el);

        //add local currency value
        $row.find('.supplier-price-currency input').val(product.currency);

        highlightApprovalProduct($el)
      } else {
        // bespoke product
        $durationSelect.find('option').remove();
        $durationSelect.select2('destroy');

        for (let i = 1; i <= 365; i++) {
          output.push({
            'id': i,
            'text': i,
          });
        }

        $durationSelect.select2({
          query: function (query) {
            //do ajax call which retrieves the results array in this format:
            var data = {
              results: output
            };
            //pass it to the query callback inside your Ajax callback:
            query.callback(data);
          }
        });

        hideSeasonArea($el);

        //add local currency value
        $row.find('.supplier-price-currency input').val(product.currency);

        highlightApprovalProduct($el)
      }
    }
  }

  function populateSeasonOptions($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    showSeasonArea($row);
    var season, budget, seasonID;
    var seasonHasData = false;
    var productID = getProductID($row);
    var duration = getDuration($row);
    var $seasonSelect = $row.find('.standard-product .season select:enabled');
    var $budgetSelect = $row.find('.standard-product .budget select:enabled');
    var currentRow = $row.data('id');

    $budgetSelect.find('option').remove();
    $budgetSelect.select2('destroy');
    $budgetSelect.select2();

    $seasonSelect.find('option').remove();
    $seasonSelect.select2('destroy');

    var product = JSON.parse(localStorage.getItem('product-' + productID));

    var output = [];

    for (season in product.pricing[duration]) {
      //ignore bookingBonus
      if(season != 'bookingBonus') {
        for (budget in product.pricing[duration][season]) {
          // does this product have agent and customer values?
          if (product.pricing[duration][season][budget].customer > 0) {
            seasonHasData = true;
          }
        }
        if(seasonHasData) {
          $seasonSelect.append('<option value="' + season + '">' + ucwords(season) + '</option>');
          output.push({
            'id': season,
            'text': ucwords(season)
          });
        } else {
          $seasonSelect.append('<option value="' + season + '" disabled>' + ucwords(season) + '</option>');
          output.push({
            'id': season,
            'text': ucwords(season),
            'disabled': true
          });
        }
        seasonHasData = false;
      }
    }

    if (localStorage.getItem(currentRow) != null) {
      seasonID = JSON.parse(localStorage.getItem(currentRow)).seasonID;
      $seasonSelect.val(seasonID);
    }

    $seasonSelect.select2({
      query: function (query) {
        //do ajax call which retrieves the results array in this format:
        var data = {
          results: output
        };
        //pass it to the query callback inside your Ajax callback:
        query.callback(data);
      }
    });

    if ($seasonSelect.select2('data')[0] != null) {
      populateBudgetOptions($el);
    }
  }

  function populateBudgetOptions($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    var budgetID;
    var productID = getProductID($el);
    var duration = getDuration($el);
    var season = getSeason($el);
    var budgetHasData = false;
    var $budgetSelect = $row.find('.standard-product .budget select:enabled');
    var currentRow = $row.data('id');

    var product = JSON.parse(localStorage.getItem('product-' + productID));

    var output = [];

    $budgetSelect.find('option').remove();
    $budgetSelect.select2('destroy');

    for (var budget in product.pricing[duration][season]) {
      if (product.pricing[duration][season][budget].customer > 0) {
        budgetHasData = true
      }
      if (budgetHasData) {
        $budgetSelect.append('<option value="' + budget + '">' + ucwords(budget) + '</option>');
        output.push({
          'id': budget,
          'text': ucwords(budget)
        });
      } else {
        $budgetSelect.append('<option value="' + budget + '" disabled>' + ucwords(budget) + '</option>')
        output.push({
          'id': budget,
          'text': ucwords(budget),
          'disabled': true
        });
      }
      budgetHasData = false;
    }

    if (localStorage.getItem(currentRow) != null) {
      budgetID = JSON.parse(localStorage.getItem(currentRow)).budgetID;
      $budgetSelect.val(budgetID);
    }

    $budgetSelect.select2({
      query: function (query) {
        //do ajax call which retrieves the results array in this format:
        var data = {
          results: output
        };
        //pass it to the query callback inside your Ajax callback:
        query.callback(data);
      }
    });

    if ($budgetSelect.select2('data')[0] != null) {
      showItemPrice($el);
    }
  }
  function setAddonOperatorBasedOnProduct($el){
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    var productID = getProductID($el);
    var product = JSON.parse(localStorage.getItem('product-' + productID));
    var $operatorSelect = $row.find('.operator select');

    if(product && product.opeator) {
      if ($operatorSelect.find("option[value='" + product.opeator.id + "']").length) {
        $operatorSelect.val(product.opeator.id).trigger('change');
      } else {
        // Create a DOM Option and pre-select by default
        var newOption = new Option(product.opeator.title, product.opeator.id, true, true);
        $operatorSelect.append(newOption).trigger('change').trigger({
          type: 'select2:select',
          params: {
            data: addingAddonItem
          }
        });
      }
    }
  }
  function showItemPrice($el) {
    let $row = $el.closest('.acf-row')
    var productID = getProductID($el);
    var qty = getQty($el);
    var currency, supplierLocal, supplierGBP, customerPricePreDiscountGBP, specialOfferDiscountGBP, customerPriceGBP, supplierMarginPerc, grossMarginGBP, bookingFeePerc, bookingFeeGBP, bookingBonusPerc = 0, bookingBonusGBP, grossMarginToSplitGBP, wtgSplitMarginGBP, wtgPayoutGBP, supplierDiscountOfferPerc, supplierDiscountOfferFixed, depositGBP, agentPayoutGBP, parentAgentPayoutGBP;

    var currentRow = $row.data('id');

    var product = JSON.parse(localStorage.getItem('product-' + productID));

    var savedData = JSON.parse(localStorage.getItem(currentRow))
    if(savedData) {

      //Destroy local data after retrieval
      localStorage.removeItem(currentRow);
    }

    if (savedData != null && savedData.amended) {

      //update output variables with the amended data!
      for (let key in savedData.savedPrices) {
        //save keys in object as variables. make sure NaNs are saved as strings
        if (isNaN(savedData.savedPrices[key])) {
          eval(key + " = '" + savedData.savedPrices[key] + "'")
        }else if ('' === savedData.savedPrices[key]){
          eval(key + " = '" + savedData.savedPrices[key] + "'")
        }else {
          eval(key + " = " + savedData.savedPrices[key])
        }
      }

    } else {

      // get pricing data from ajax returned product
      currency = product.currency;
      if (!currency) {
        currency = 'GBP';
      }
      var pricingData = {};
      if(product.standard && product.is_addon && !product.is_addon_durational) {
        pricingData = product.pricing;
      }else{
        var duration = getDuration($el);
        pricingData = product.pricing[duration];
      }

      if (product.seasonal) {

        var season = getSeason($el);
        var budget = getBudget($el);

        supplierLocal = pricingData[season][budget].supplierLocal;
        supplierGBP = pricingData[season][budget].supplierGBP;
        customerPricePreDiscountGBP = pricingData[season][budget].customerPreDiscount;
        customerPriceGBP = pricingData[season][budget].customer;
        supplierMarginPerc = pricingData[season][budget].supplierMarginPerc;
        grossMarginGBP = pricingData[season][budget].grossMargin;
        bookingFeeGBP = pricingData[season][budget].bookingFeeGBP;
        bookingBonusPerc = pricingData[season][budget].bookingBonusPerc;
        bookingBonusGBP = pricingData[season][budget].bookingBonusGBP;
        grossMarginToSplitGBP = pricingData[season][budget].grossMarginToSplitGBP;
        wtgSplitMarginGBP = pricingData[season][budget].wtgSplitMarginGBP;
        wtgPayoutGBP = pricingData[season][budget].wtgPayout;
        agentPayoutGBP = pricingData[season][budget].agentPayout;
        parentAgentPayoutGBP = pricingData[season][budget].parentAgentPayout;

      } else {

        supplierLocal = pricingData.supplierLocal;
        supplierGBP = pricingData.supplierGBP;
        customerPricePreDiscountGBP = pricingData.customerPreDiscount;
        customerPriceGBP = pricingData.customer;
        supplierMarginPerc = pricingData.supplierMarginPerc;
        grossMarginGBP = pricingData.grossMargin;
        bookingFeeGBP = pricingData.bookingFeeGBP;
        bookingBonusPerc = pricingData.bookingBonusPerc;
        bookingBonusGBP = pricingData.bookingBonusGBP;
        grossMarginToSplitGBP = pricingData.grossMarginToSplitGBP;
        wtgSplitMarginGBP = pricingData.wtgSplitMarginGBP;
        wtgPayoutGBP = pricingData.wtgPayout;
        agentPayoutGBP = pricingData.agentPayout;
        parentAgentPayoutGBP = pricingData.parentAgentPayout;
      }

      //overwrite deposit with fixedval if we have it
      if(product.marginDepositFixedVal !== null && product.marginDepositFixedVal.length)  {
        depositGBP = product.marginDepositFixedVal;
      } else {
        depositGBP = customerPriceGBP * (product.deposit / 100);
      }

      supplierDiscountOfferPerc = product.supplierDiscountOffer;
      supplierDiscountOfferFixed = product.supplierDiscountOfferFixed;
      bookingFeePerc = product.bookingFeePerc;

      specialOfferDiscountGBP = customerPricePreDiscountGBP - customerPriceGBP;
    }

    //hidden values for audit
    $row.find('.supplier-price-currency input').val(currency);
    $row.find('.supplier-price-local input').val((supplierLocal * qty).toFixed(2));
    $row.find('.supplier-price-gbp input').val((supplierGBP * qty).toFixed(2));

    $row.find('.customer-price-pre-discount input').val((customerPricePreDiscountGBP * qty).toFixed(2));

    $row.find('.special-offer-discount input').val((specialOfferDiscountGBP * qty).toFixed(2));

    $row.find('.customer-price-gbp input').val((customerPriceGBP * qty).toFixed(2));
    $row.find('.supplier-margin-perc input').val(supplierMarginPerc.toFixed(2));

    $row.find('.gross-margin input').val((grossMarginGBP * qty).toFixed(2));

    $row.find('.booking-fee input').val(bookingFeePerc.toFixed(2));
    $row.find('.booking-fee-gbp input').val((bookingFeeGBP * qty).toFixed(2));

    $row.find('.booking-bonus input').val(bookingBonusPerc.toFixed(2));
    $row.find('.booking-bonus-gbp input').val((bookingBonusGBP * qty).toFixed(2));

    $row.find('.gross-margin-to-split-gbp input').val((grossMarginToSplitGBP * qty).toFixed(2));
    $row.find('.wtg-split-margin-gbp input').val((wtgSplitMarginGBP * qty).toFixed(2));

    $row.find('.wtg-payout input').val((wtgPayoutGBP * qty).toFixed(2));
    $row.find('.supplier-discount-offer input').val(supplierDiscountOfferPerc.toFixed(2));
    $row.find('.supplier-discount-offer-fixed input').val(supplierDiscountOfferFixed.toFixed(2));
    $row.find('.item-deposit input').val((depositGBP * qty).toFixed(2));

    //visible values which are totalled
    $row.find('.item-price input').val((customerPriceGBP * qty).toFixed(2));
    $row.find('.item-agent-payout input').val((agentPayoutGBP * qty).toFixed(2));
    $row.find('.item-parent-agent-payout input').val((parentAgentPayoutGBP * qty).toFixed(2));


    //add data values so we can update the input fields
    $row.find('.item-price input').data('price', (customerPriceGBP * qty).toFixed(2));
    $row.find('.item-agent-payout input').data('price', (agentPayoutGBP * qty).toFixed(2));
    $row.find('.item-parent-agent-payout input').data('price', (parentAgentPayoutGBP * qty).toFixed(2));

    highlightApprovalProduct($el);
    updateMaxDiscount($el);
    addDiscountToItem($el);

    updateTotal();
  }

  function updateMaxDiscount($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    var maxDiscount = $row.find('.item-agent-payout input').val();

    $row.find('.max-discount').remove();
    $row.find('.item-discount .acf-label').append('<span class="max-discount">(up to a maximum of <strong>&pound;' + maxDiscount + ')</strong></span>');
  }

  function addDiscountToItem($el) {
    let $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    var price = parseFloat($row.find('.item-price input:enabled').data('price'));
    var daPayout = parseFloat($row.find('.item-agent-payout input:enabled').data('price'));

    var discount = $row.find('.item-discount input').val();

    if(discount > daPayout) {
      alert('Discount too high. You may only discount from your margin. Please reduce to an amount less than £' + daPayout);
      $row.find('.item-discount input').val('0.00');
      discount = 0;
    }

    if(discount < 0) {
      alert('You may only discount positive amounts');
      $row.find('.item-discount input').val('0.00');
      discount = 0;
    }

    $row.find('.item-price input').val((price - discount).toFixed(2));
    $row.find('.item-agent-payout input').val((daPayout - discount).toFixed(2));
  }

  function hideSeasonArea($el) {
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $row.find('.season, .budget').hide();
  }

  function showSeasonArea($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $el.find('.season, .budget').show();
  }

  function showProductArea($el) {
    if(!$el.hasClass('acf-row')) {
      $el = $el.closest('.acf-row');
    }
    $el.find('.standard-product, .bespoke-product').show();
    hideSeasonArea($el);
  }

  function hideProductArea($el) {
    $el = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $el.find('.standard-product, .bespoke-product, .season, .budget').hide();
  }
  function showDurationArea($el) {
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $row.find('.duration').show();
  }
  function hideDurationArea($el) {
    var $row = $el.hasClass('acf-row') ? $el : $el.closest('.acf-row');
    $row.find('.duration').hide();
  }

  function handlePackageItemLocking($row){
    if($('body').hasClass('approve-quote')) {
      return;
    }
    if($row.data('is_locked')) {
      $row.addClass('row-locked').removeClass('row-unlocked');
      /*
      if(!$row.find('.num-pax .acf-input input').prop('readonly')) {
        $row.find('.num-pax').addClass('input-locked').find('.acf-input input').prop('readonly', true);
      }
      if(!$row.find('.start-date .acf-input input').prop('readonly')) {
        $row.find('.start-date').addClass('input-locked').find('.acf-input input').prop('readonly', true);
      }
      if(!$row.find('.end-date .acf-input input').prop('readonly')) {
        $row.find('.end-date').addClass('input-locked').find('.acf-input input').prop('readonly', true);
      }
      if(!$row.find('.operator .acf-input select').prop('readonly')) {
        $row.find('.operator').addClass('input-locked').find('.acf-input select').prop('readonly', true);
      }
      if(!$row.find('.product .acf-input select').prop('readonly')) {
        $row.find('.product').addClass('input-locked').find('.acf-input select').prop('readonly', true);
      }
      if(!$row.find('.duration .acf-input select').prop('readonly')) {
        $row.find('.duration').addClass('input-locked').find('.acf-input select').prop('readonly', true);
      }
      if(!$row.find('.season select').prop('readonly')) {
        $row.find('.season').addClass('input-locked').find('.acf-input select').prop('readonly', true);
      }
      if(!$row.find('.bespoke-countries .acf-input select').prop('readonly')) {
        $row.find('.bespoke-countries').addClass('input-locked').find('.acf-input select').prop('readonly', true);
      }
      */
    }else{
      //$row.find('.input-locked').removeClass('input-locked').find('.acf-input input,.acf-input select').prop('readonly', false);
      $row.removeClass('row-locked').addClass('row-unlocked');
    }
  }

  function packageItemsReady($row, appended) {
    appended = appended || false;
    //clear local stored data when package item is amended
    $('.operator, .product, .duration, .season, .budget', $row).on('select2:select', function () {
      //remove admin-amended checkbox so product has to be approved again
      $(this).closest('.acf-row').find('.admin-amended input[type="checkbox"]').prop('checked', false)

      highlightApprovalProduct($(this))

      var currentRow = $(this).closest('.acf-row').data('id');

      if (localStorage.getItem(currentRow)) {
        localStorage.removeItem(currentRow);
      }
    })

    if($row.hasClass('pi-is-standalone-addon')) {
      // Standalone addon: operator select loads all addon products and shows country filter
      $('.operator', $row).on('select2:select', function (e){
        showProductArea($row);
        $row.find('.bespoke-countries').removeClass('d-none');
        $row.find('.bespoke-countries select').val(null).trigger('change');
        var operatorID = e.params.data.id;
        getStandaloneAddonProducts($row, operatorID);
      });
      // Country select re-loads products filtered by country
      $('.bespoke-countries', $row).on('select2:select', 'select', function (e){
        var operatorID = $('.operator select', $row).val();
        var countryID = e.params.data.id;
        getStandaloneAddonProducts($row, operatorID, countryID);
      });
    } else if($row.hasClass('pi-is-addon')) {
      $('.addon-main-product', $row).on('select2:select', function (e){
        showProductArea($row);
        var productID = e.params.data.id;
        getAddonProductOptions($row, productID);
      });
      if(appended) {
        if($('.addon-main-product select', $row).val()){
          showProductArea($row);
          getAddonProductOptions($row, $('.addon-main-product select', $row).val());
        }
      }
    }else{
      $('.operator', $row).on('select2:select', function (e){
        showProductArea($(this));
        var operatorID = e.params.data.id;
        getProductOptions($(this), operatorID);
      });
    }

    //Standard Product Events
    $('.product', $row).on('select2:select', function () {
      var productID = getProductID($(this));
      var product = JSON.parse(localStorage.getItem('product-' + productID));
      if($(this).closest('.acf-row').hasClass('pi-is-addon') && !$(this).closest('.acf-row').hasClass('pi-is-standalone-addon')) {
        setAddonOperatorBasedOnProduct($(this));
      }
      hideSeasonArea($(this));
      addProductLink($(this));
      highlightApprovalProduct($(this));
      if(product.standard && product.is_addon && !product.is_addon_durational) {
        $row.addClass('pi-addon-non-durational');
        $row.find('.non-durational input[type="checkbox"]').prop('checked', true);
        hideDurationArea($(this));
        hideSeasonArea($(this));
        showItemPrice($(this));
      }else{
        $row.find('.non-durational input[type="checkbox"]').prop('checked', false);
        populateDurationOptions($(this));
      }

      showHideItemBespokeFields($(this).closest('.acf-row'));
      handlePackageItemApproveField($(this).closest('.acf-row'));
    })

    $('.duration', $row).on('select2:select', function () {
      var productID = getProductID($(this));
      var product = JSON.parse(localStorage.getItem('product-' + productID));

      if (product.standard) {
        if (product.seasonal) {
          populateSeasonOptions($(this));
        } else {
          hideSeasonArea($(this));
          showItemPrice($(this));
        }
      }
    })

    $('.season', $row).on('select2:select', function () {
      populateBudgetOptions($(this));
    })

    $('.budget', $row).on('select2:select', function () {
      showItemPrice($(this));
    })

    //Quantity amended
    $('.num-pax input', $row).on('change', function() {
      var $qtyRow = $(this).closest('.acf-row');
      //Tailor Made prices are trip totals; qty is the participant count and must not scale them
      if($qtyRow.hasClass('row-tailor-made') || $qtyRow.find('.tailor-made input[type="checkbox"]').is(':checked')) {
        return;
      }
      showItemPrice($(this));
    });
    //Discount amended
    $('.item-discount input:enabled', $row).on('change', function() {
      addDiscountToItem($(this));
      updateTotal();
    });

    //Events for total
    $('#additional-markup input:enabled').on('change', function () {
      updateTotal();
    })

    $('#deposit-markup input:enabled').on('change', function () {
      updateTotal();
    })

    //Approve Quote
    $('.supplier-price-local input:enabled, .customer-price-gbp input:enabled', $row).on('change', function() {
      if(!$(this).closest('.acf-row').hasClass('row-tailor-made')) {
        updateApprovalItem($(this));
      }
    });
    //Approve Tailor Made
    $('.supplier-price-local input:enabled, .customer-price-local input:enabled, .customer-price-gbp input:enabled, .supplier-margin-perc input:enabled, .supplier-deposit-perc input:enabled', $row).on('change', function() {
      if($(this).closest('.acf-row').hasClass('row-tailor-made')) {
        updateTailorMadeProductApprovalItem($(this))
      }
    });
    $('.supplier-price-currency-dd select', $row).on('select2:select', function (){
      if($(this).closest('.acf-row').hasClass('row-tailor-made')) {
        updateExchangeRateDisplay($(this));
        updateTailorMadeProductApprovalItem($(this));
      }
    });
    $('.customer-price-gbp', $row).find('.acf-label').append('<span class="wtg-exchange-rate"></span>');
    updateExchangeRateDisplay($row);
  }

  function flightItemsReady() {
    //Flight item events
    $('#flight-items input:enabled').on('change', function() {
      updateFlightTotal($(this));
    })
  }
  function setPackageItemsDependencies(){
    let packageItemsField = acf.getField('field_5c6c1967d0e0d');
    if(packageItemsField.getValue() < 1) {
      $body.addClass('has-no-package-items');
    }else{
      $body.removeClass('has-no-package-items');
    }
  }

  function bookingLoaded() {
    //disable all total fields
    $('#totals input:enabled').prop('readonly', true);
    disableBookingFields();
    var packageItemsRepeater = acf.getField('field_5c6c1967d0e0d');
    if (packageItemsRepeater) {
      packageItemsRepeater.$rows().each(function () {
        var $row = $(this);
        var isAddonRow = $row.find('.is-addon-item input.acf-switch-input').prop('checked');
        if(isAddonRow) {
          $row.addClass('pi-is-addon');
        }
        var isStandaloneAddonRow = $row.find('.is-standalone-addon-item input.acf-switch-input').prop('checked');
        if(isStandaloneAddonRow) {
          $row.addClass('pi-is-standalone-addon');
        }
        var savedData = getSavedData($(this));

        $row.find('option').remove();
        $row.find('select:enabled').select2('destroy');
        if(isAddonRow && !isStandaloneAddonRow) {
          $row.find('.addon-main-product select:enabled').append('<option value="' + savedData.main_product_id + '">' + savedData.main_product_text + '</option>');
        }
        $row.find('.operator select:enabled').append('<option value="' + savedData.operatorID + '">' + savedData.operatorText + '</option>');
        $row.find('.product select:enabled').append('<option value="' + savedData.productID + '">' + savedData.productText + '</option>');

        if(savedData.standard) {
          $row.addClass('standard');
          $row.find('.standard-product .duration select:enabled').append('<option value="' + savedData.duration + '">' + savedData.duration + '</option>');
          $row.find('.standard-product .season select:enabled').append('<option value="' + savedData.seasonID + '">' + savedData.seasonText + '</option>');
          $row.find('.standard-product .budget select:enabled').append('<option value="' + savedData.budgetID + '">' + savedData.budgetText + '</option>');
        }else{
          $row.find('.standard-product .bespoke-countries select:enabled').append('<option value="' + savedData.TMcountryID + '">' + savedData.TMcountryText + '</option>');
          $row.find('.standard-product .duration select:enabled').append('<option value="' + savedData.duration + '">' + savedData.duration + '</option>');
        }
        showHideItemBookingTailorMadefields($row, !savedData.standard);
      });
    }

    // ACF actions for new rows (standalone addons)
    acf.addAction('append', function ($el) {
      if($el.parents('#package-items').length && !$el.parents('.pi_itinerary_details').length && !$el.parents('.pi_rel_part_docs').length) {
        $el.find('.unlock-item').addClass('d-none');
        $el.find('.hidden-fields input:enabled').not('input[type="radio"], input[type="checkbox"]').prop('readonly', true);
        $el.find('.package-item-price input:enabled').prop('readonly', true);
        $el.find('.item-deposit input:enabled').prop('readonly', true);
        if(addingAddonItem) {
          prepareAddonPackageItem($el);
        }
        hideProductArea($el);

        addDateLinkPackageItem($el);
        autoPopulateEndDate($el);

        disableItemFields($el);
        hideItemBespokeFields($el);
        packageItemsReady($el, true);
      }

      $el.find('.trigger-tooltip').on('click', function () {
        $(this).closest('.acf-label').find('.description').slideToggle('fast');
      });

      let $row = $el.closest('.acf-row');
      setTimeout(function(){
        window.scrollTo({
          top: $row.offset().top,
          behavior: 'smooth'
        });
      }, 100);

      setPackageItemsDependencies();
    });
  }

  function enquiryLoaded() {
    // on page load - restrict products and update margins for operators/products already selected
    var packageItemsRepeater = acf.getField('field_5c6c1967d0e0d');
    if (packageItemsRepeater) {
      packageItemsRepeater.$rows().each(function () {
        var savedData;
        var $row = $(this);
        var rowId = $row.data('id');
        var isAddonRow = $row.find('.is-addon-item input.acf-switch-input').prop('checked');
        if(isAddonRow) {
          $row.addClass('pi-is-addon');
        }
        var isStandaloneAddonRow = $row.find('.is-standalone-addon-item input.acf-switch-input').prop('checked');
        if(isStandaloneAddonRow) {
          $row.addClass('pi-is-standalone-addon');
        }
        savedData = normalizeSavedPricesPerUnit(getSavedData($(this)), $row);
        localStorage.setItem(rowId, JSON.stringify(savedData));
        disableItemFields($(this));
        hideItemBespokeFields($(this).closest('.acf-row'));
        if(isStandaloneAddonRow) {
          showProductArea($row);
          getStandaloneAddonProducts($row, savedData.operatorID);
        } else if(isAddonRow) {
          showProductArea($row);
          getAddonProductOptions($row, savedData.main_product_id, savedData.discount);
        }else{
          if($row.find('.operator select:enabled').select2('data').length) {
            getProductOptions($row, savedData.operatorID, savedData.discount);
          }else{
            hideProductArea($row);
          }
        }
      });
    }

    $('#flight-items .flight-total input:enabled').each(function() {
      disableFlightFields($(this));
      flightItemsReady();
    });

    // remove total price readonly property when enquiry type is not PAX
    $('#product-type input').on('click', function () {
      var type = $(this).val();
      if (type === 'pax') {
        $('#total-price input:enabled').prop('readonly', true);
      } else {
        $('#total-price input:enabled').prop('readonly', false);
      }
    });

    // ACF actions
    // add a new repeater row
    acf.addAction('append', function ($el) {
      // $el -> tr.acf-row
      if($el.parents('#package-items').length && !$el.parents('.pi_itinerary_details').length && !$el.parents('.pi_rel_part_docs').length) {
        $el.find('.unlock-item').addClass('d-none');
        //disable package item fields
        $el.find('.hidden-fields input:enabled').not('input[type="radio"], input[type="checkbox"]').prop('readonly', true);
        $el.find('.package-item-price input:enabled').prop('readonly', true);
        $el.find('.item-deposit input:enabled').prop('readonly', true);
        if(addingAddonItem) {
          prepareAddonPackageItem($el);
        }
        hideProductArea($el);

        addDateLinkPackageItem($el);
        autoPopulateEndDate($el);

        disableItemFields($el);
        hideItemBespokeFields($el);
        packageItemsReady($el, true);
      }

      if($el.parents('#flight-items').length) {
        $el.find('.flight-total input:enabled').prop('readonly', true);
        $el.find('.flight-total-apc input:enabled').prop('readonly', true);

        disableFlightFields($el);
        flightItemsReady();
      }

      //enable item tooltips
      $el.find('.trigger-tooltip').on('click', function () {
        $(this).closest('.acf-label').find('.description').slideToggle('fast');
      });

      //scroll to top of new repeater
      let $row = $el.closest('.acf-row');
      setTimeout(function(){
        window.scrollTo({
          top: $row.offset().top,
          behavior: 'smooth'
        });

      }, 100);

      setPackageItemsDependencies();
    });

    acf.addAction('remove', function () {
      // This is horrible. However cannot obtain event for when row removal is complete
      setTimeout(function(){
        updateTotal();
        setPackageItemsDependencies();
      }, 500)
    });

    disableMainFields();

    addDateLinkTailorMade();

    // wait for events on each package item
    var pi_index = 0;
    $('#package-items .acf-row').each(function (){
      var $row = $(this);
      if(!$row.hasClass('acf-clone') && !$row.parents('.pi_itinerary_details').length && !$row.parents('.pi_rel_part_docs').length){
        //Add notes link
        $row.find('>.acf-fields').prepend('<button type="button" class="btn btn-sm btn-primary btn-pi-note-modal" data-toggle="modal" data-target="#item-notes-pi_note_modal_' + pi_index + '">' + optionsJS.SVGs_eye + 'Notes</button>');
        $row.data('is_locked', true);
        packageItemsReady($row);
        pi_index++;
      }
    });
    $('#package-items').on('change', '.start-date input.input, .end-date input.input', function (){
      var $row = $(this).closest('.acf-row');
      if($row.hasClass('row-tailor-made')){
        var output = [];
        var tailor_mdae_nights = calculateNightsForItem($row);
        var $durationSelect = $row.find('.standard-product .duration select:enabled');
        $durationSelect.find('option').remove();
        $durationSelect.select2('destroy');
        output.push({
          'id': tailor_mdae_nights,
          'text': tailor_mdae_nights,
        });
        $durationSelect
            .append('<option value="'+ tailor_mdae_nights +'" selected="selected">' + tailor_mdae_nights + '</option>')
            .select2({
              query: function (query) {
                //do ajax call which retrieves the results array in this format:
                var data = {
                  results: output
                };
                //pass it to the query callback inside your Ajax callback:
                query.callback(data);
              }
            })
            .trigger('select2:select');
      }

    });
    $('#package-items').on('change', '.supplier-price-calc-type input[type="radio"]', function (){
      var $row = $(this).closest('.acf-row');
      if($row.hasClass('row-tailor-made')){
        if($(this).val() === 'customer') {
          $row.find('.customer-price-gbp input').prop('readonly', true).val('');
          $row.find('.customer-price-local input').prop('readonly', false).val('');
          $row.find('.supplier-price-local input').prop('readonly', true).val('');
          $row.find('.supplier-margin-perc input').prop('readonly', false).val('');
        }else if($(this).val() === 'operator'){
          $row.find('.customer-price-gbp input').prop('readonly', true).val('');
          $row.find('.customer-price-local input').prop('readonly', true).val('');
          $row.find('.supplier-price-local input').prop('readonly', false).val('');
          $row.find('.supplier-margin-perc input').prop('readonly', false).val('');
        }else{
          $row.find('.customer-price-gbp input').prop('readonly', false).val('');
          $row.find('.customer-price-local input').prop('readonly', true).val('');
          $row.find('.supplier-price-local input').prop('readonly', false).val('');
          $row.find('.supplier-margin-perc input').prop('readonly', true).val('');
        }
        clearTailorMadeDerivedFields($row);
        updateTotal();
      }

    });
    $('#package-items').on('change', '.pi-approve-item input[type="checkbox"]', function (){
      if(this.checked && $body.hasClass('approve-quote')) {
        $('.acf-field[data-name="admin_approved"] input[type="checkbox"]').prop('checked', true);
        $('.acf-field[data-name="admin_approved"] input').val(1);
      }
    });
    $('#tailor-made-switch .acf-switch-input').on('change', function (){
      !$('#tailor-made .tailor-made-id-details textarea').val() && $('#tailor-made .tailor-made-id-details textarea').prop('readonly', false);
    });
    $('#package-items').on('change', '.unlock-item input[type="checkbox"]', function (){
      var $row = $(this).closest('.acf-row');
      $row.data('is_locked', !this.checked);
      handlePackageItemLocking($row);
    });

  }

  // =====
  setupTooltips();

  $('#dates .start-date input, #dates .end-date input').change(function () {
    calculateNights();
  });


  acf.addAction('show_field', function(field) {
    if(field.data.name == 'flight_items') {
      monitorIncludeFlightButton();
    }
  })

  monitorIncludeFlightButton();
  autoPopulateEndDate();

  localStorage.clear();

  acf.addAction('load', function () {
    if($('main').hasClass('booking-amendment')) {
      bookingAmendmentLoaded();
    } else if($('main').hasClass('booking')) {
      bookingLoaded();
    } else {
      enquiryLoaded();
    }
    setPackageItemsDependencies();
  });

  function bookingAmendmentLoaded() {
    var existingItemCount = parseInt($('main').attr('data-existing-item-count')) || 0;

    // Disable main fields and booking fields for existing items
    disableMainFields();
    disableBookingFields();
    addDateLinkTailorMade();

    var packageItemsRepeater = acf.getField('field_5c6c1967d0e0d');
    if (packageItemsRepeater) {
      var rowIndex = 0;
      packageItemsRepeater.$rows().each(function () {
        var $row = $(this);
        if($row.hasClass('acf-clone') || $row.parents('.pi_itinerary_details').length || $row.parents('.pi_rel_part_docs').length) {
          return;
        }
        var isAddonRow = $row.find('.is-addon-item input.acf-switch-input').prop('checked');
        if(isAddonRow) {
          $row.addClass('pi-is-addon');
        }
        var isStandaloneAddonRow = $row.find('.is-standalone-addon-item input.acf-switch-input').prop('checked');
        if(isStandaloneAddonRow) {
          $row.addClass('pi-is-standalone-addon');
        }

        if(rowIndex < existingItemCount) {
          // EXISTING ROW — lock like bookingLoaded()
          var savedData = getSavedData($(this));
          $row.find('option').remove();
          $row.find('select:enabled').select2('destroy');
          if(isAddonRow && !isStandaloneAddonRow) {
            $row.find('.addon-main-product select:enabled').append('<option value="' + savedData.main_product_id + '">' + savedData.main_product_text + '</option>');
          }
          $row.find('.operator select:enabled').append('<option value="' + savedData.operatorID + '">' + savedData.operatorText + '</option>');
          $row.find('.product select:enabled').append('<option value="' + savedData.productID + '">' + savedData.productText + '</option>');

          if(savedData.standard) {
            $row.addClass('standard');
            $row.find('.standard-product .duration select:enabled').append('<option value="' + savedData.duration + '">' + savedData.duration + '</option>');
            $row.find('.standard-product .season select:enabled').append('<option value="' + savedData.seasonID + '">' + savedData.seasonText + '</option>');
            $row.find('.standard-product .budget select:enabled').append('<option value="' + savedData.budgetID + '">' + savedData.budgetText + '</option>');
          } else {
            $row.find('.standard-product .bespoke-countries select:enabled').append('<option value="' + savedData.TMcountryID + '">' + savedData.TMcountryText + '</option>');
            $row.find('.standard-product .duration select:enabled').append('<option value="' + savedData.duration + '">' + savedData.duration + '</option>');
          }
          showHideItemBookingTailorMadefields($row, !savedData.standard);
          $row.data('is_locked', true);
          $row.addClass('row-locked');

          // Still show "Include Add-On" on existing rows that have addons
          var productID = savedData.productID;
          var productTitle = savedData.productText;
          var product = JSON.parse(localStorage.getItem('product-' + productID));
          // We may not have product in localStorage for locked rows, so check savedData
          $row.find('.standard-product .product .add-addon-package-item').remove();
          if(!isAddonRow) {
            // Re-add the Include Add-On button via AJAX product check
            $row.find('.standard-product .product .acf-label').append('<a class="add-addon-package-item" href="#" data-pid="' + productID + '" data-title="' + productTitle + '" style="display:none;">Include Add-On</a>');
            // Quick check if product has addons
            $.ajax({
              url: tofinoJS.ajaxUrl,
              type: 'POST',
              data: {
                action: 'getProductOptions',
                value: {
                  is_addon: true,
                  main_product_id: productID,
                  enquiry_id: new URLSearchParams(window.location.search).get('enquiry_id')
                }
              },
              dataType: 'json'
            }).done(function(response) {
              if(response && response.length > 0) {
                $row.find('.add-addon-package-item').show();
              } else {
                $row.find('.add-addon-package-item').remove();
              }
            });
          }
        } else {
          // NEW ROW — interactive like enquiryLoaded()
          savedData = normalizeSavedPricesPerUnit(getSavedData($(this)), $row);
          var rowId = $row.data('id');
          localStorage.setItem(rowId, JSON.stringify(savedData));
          disableItemFields($(this));
          hideItemBespokeFields($(this).closest('.acf-row'));
          if(isStandaloneAddonRow) {
            showProductArea($row);
            getStandaloneAddonProducts($row, savedData.operatorID);
          } else if(isAddonRow) {
            showProductArea($row);
            getAddonProductOptions($row, savedData.main_product_id, savedData.discount);
          } else {
            if($row.find('.operator select:enabled').select2('data').length) {
              getProductOptions($row, savedData.operatorID, savedData.discount);
            } else {
              hideProductArea($row);
            }
          }
          $row.data('is_locked', true);
          packageItemsReady($row);
        }
        rowIndex++;
      });
    }

    $('#flight-items .flight-total input:enabled').each(function() {
      disableFlightFields($(this));
      flightItemsReady();
    });

    // ACF actions for new rows
    acf.addAction('append', function ($el) {
      if($el.parents('#package-items').length && !$el.parents('.pi_itinerary_details').length && !$el.parents('.pi_rel_part_docs').length) {
        $el.find('.unlock-item').addClass('d-none');
        $el.find('.hidden-fields input:enabled').not('input[type="radio"], input[type="checkbox"]').prop('readonly', true);
        $el.find('.package-item-price input:enabled').prop('readonly', true);
        $el.find('.item-deposit input:enabled').prop('readonly', true);
        if(addingAddonItem) {
          prepareAddonPackageItem($el);
        }
        hideProductArea($el);

        addDateLinkPackageItem($el);
        autoPopulateEndDate($el);

        disableItemFields($el);
        hideItemBespokeFields($el);
        packageItemsReady($el, true);
      }

      if($el.parents('#flight-items').length) {
        $el.find('.flight-total input:enabled').prop('readonly', true);
        $el.find('.flight-total-apc input:enabled').prop('readonly', true);
        disableFlightFields($el);
        flightItemsReady();
      }

      $el.find('.trigger-tooltip').on('click', function () {
        $(this).closest('.acf-label').find('.description').slideToggle('fast');
      });

      let $row = $el.closest('.acf-row');
      setTimeout(function(){
        window.scrollTo({
          top: $row.offset().top,
          behavior: 'smooth'
        });
      }, 100);

      setPackageItemsDependencies();
    });

    acf.addAction('remove', function () {
      setTimeout(function(){
        updateTotal();
        setPackageItemsDependencies();
      }, 500)
    });

    // Package item date changes for tailor-made
    $('#package-items').on('change', '.start-date input.input, .end-date input.input', function (){
      var $row = $(this).closest('.acf-row');
      if($row.hasClass('row-tailor-made')){
        var output = [];
        var tailor_made_nights = calculateNightsForItem($row);
        var $durationSelect = $row.find('.standard-product .duration select:enabled');
        $durationSelect.find('option').remove();
        $durationSelect.select2('destroy');
        output.push({ 'id': tailor_made_nights, 'text': tailor_made_nights });
        $durationSelect
          .append('<option value="'+ tailor_made_nights +'" selected="selected">' + tailor_made_nights + '</option>')
          .select2({
            query: function (query) { query.callback({ results: output }); }
          })
          .trigger('select2:select');
      }
    });

    $('#package-items').on('change', '.unlock-item input[type="checkbox"]', function (){
      var $row = $(this).closest('.acf-row');
      $row.data('is_locked', !this.checked);
      handlePackageItemLocking($row);
    });

    // Confirmation modal for amendment submission
    var $form = $('form.fixed-submit');
    if($form.length) {
      // Add confirmation modal HTML
      $('body').append(
        '<div class="modal fade" id="amendment-confirm-modal" tabindex="-1" role="dialog">' +
          '<div class="modal-dialog" role="document">' +
            '<div class="modal-content">' +
              '<div class="modal-header"><h5 class="modal-title">Confirm Booking Amendment</h5>' +
                '<button type="button" class="close" data-dismiss="modal"><span>&times;</span></button></div>' +
              '<div class="modal-body"><p>You are about to amend this booking by adding new items.</p>' +
                '<div id="amendment-summary"></div></div>' +
              '<div class="modal-footer">' +
                '<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>' +
                '<button type="button" class="btn btn-primary" id="confirm-amendment-btn">Confirm Amendment</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );

      var submitting = false;
      $form.on('submit', function(e) {
        if(submitting) return true;

        // Check if new rows have been added
        var currentRows = packageItemsRepeater ? packageItemsRepeater.$rows().not('.acf-clone').length : 0;
        if(currentRows > existingItemCount) {
          e.preventDefault();

          // Build summary of new items
          var summaryHtml = '<ul>';
          var idx = 0;
          packageItemsRepeater.$rows().not('.acf-clone').each(function() {
            if(idx >= existingItemCount) {
              var $row = $(this);
              var productName = $row.find('.product select option:selected').text() || 'New item';
              var startDate = $row.find('.start-date input.input').val() || '-';
              summaryHtml += '<li><strong>' + productName + '</strong> (from ' + startDate + ')</li>';
            }
            idx++;
          });
          summaryHtml += '</ul>';
          $('#amendment-summary').html(summaryHtml);

          $('#amendment-confirm-modal').modal('show');
          return false;
        }
      });

      $(document).on('click', '#confirm-amendment-btn', function() {
        submitting = true;
        $('#amendment-confirm-modal').modal('hide');
        $form.submit();
      });
    }

    // Notes buttons for existing rows
    var pi_index = 0;
    $('#package-items .acf-row').each(function (){
      var $row = $(this);
      if(!$row.hasClass('acf-clone') && !$row.parents('.pi_itinerary_details').length && !$row.parents('.pi_rel_part_docs').length){
        $row.find('>.acf-fields').prepend('<button type="button" class="btn btn-sm btn-primary btn-pi-note-modal" data-toggle="modal" data-target="#item-notes-pi_note_modal_' + pi_index + '">' + optionsJS.SVGs_eye + 'Notes</button>');
        pi_index++;
      }
    });
  }

  function getStandaloneAddonProducts($row, operatorID, countryID) {
    addLoading($row);
    const params = new URLSearchParams(window.location.search);
    var ajaxData = {
      action: 'getProductOptions',
      value: {
        is_addon: true,
        operator_id: operatorID,
        enquiry_id: params.get('enquiry_id')
      }
    };
    if(countryID) {
      ajaxData.value.country_id = countryID;
    }
    $.ajax({
      url: tofinoJS.ajaxUrl,
      type: 'POST',
      data: ajaxData,
      dataType: 'json'
    })
    .done(function(response) {
      removeLoading($row);
      populateProducts($row, response);
      handlePackageItemLocking($row);
    })
    .fail(function (jqXHR, textStatus) {
      removeLoading($row);
    })
  }

  function prepareAddonPackageItem($addonRow) {
    $addonRow.addClass('pi-is-addon');
    var addonField = acf.getFields({
      key: 'field_69649d155d252',
      parent: $addonRow,
      limit: 1
    })[0];
    addonField.$input().prop('checked', true).trigger('change');

    // Standalone addon: skip main product pre-selection, let operator be selectable
    if(addingAddonItem.standalone) {
      $addonRow.addClass('pi-is-standalone-addon');
      var standaloneField = acf.getFields({
        key: 'field_69c1fab35ea86',
        parent: $addonRow,
        limit: 1
      })[0];
      if(standaloneField) {
        standaloneField.$input().prop('checked', true).trigger('change');
      }
      // Operator select loads all addon products and shows country filter
      $('.operator', $addonRow).on('select2:select', function (e) {
        showProductArea($addonRow);
        $addonRow.find('.bespoke-countries').removeClass('d-none');
        $addonRow.find('.bespoke-countries select').val(null).trigger('change');
        var operatorID = e.params.data.id;
        getStandaloneAddonProducts($addonRow, operatorID);
      });
      // Country select re-loads products filtered by country
      $('.bespoke-countries', $addonRow).on('select2:select', 'select', function (e) {
        var operatorID = $('.operator select', $addonRow).val();
        var countryID = e.params.data.id;
        getStandaloneAddonProducts($addonRow, operatorID, countryID);
      });
      return;
    }

    var mainProductField = acf.getFields({
      key: 'field_69649d475d253',
      parent: $addonRow,
      limit: 1
    })[0];

    // Set the value, creating a new option if necessary
    if(addingAddonItem.productId) {
      if (mainProductField.$input().find("option[value='" + addingAddonItem.productId + "']").length) {
        mainProductField.$input().val(addingAddonItem.productId).trigger('change');
      } else {
        // Create a DOM Option and pre-select by default
        var newOption = new Option(addingAddonItem.productTitle, addingAddonItem.productId, true, true);
        // Append it to the select
        mainProductField.$input().append(newOption).trigger('change').trigger({
          type: 'select2:select',
          params: {
            data: addingAddonItem
          }
        });
      }
    }
  }

  if($body.hasClass('add-enquiry')) {
    //new enquiry
    let brandId = $('#enquiry-data').data('brandid')

    //automatically populate Brand Association field with contact's brand
    if(brandId) {
      let $input = $('#brand-association').find('li[data-id="' + brandId + '"] input')
      $input.prop('checked', true)
    }
  }
  $body.on('click', '.add-addon-package-item', function (e) {
    e.preventDefault();
    addingAddonItem = {
      productId:  $(this).data('pid'),
      productTitle:  $(this).data('title'),
    };
    var packageItemsField = acf.getField('field_5c6c1967d0e0d');
    var $row = packageItemsField.add();
    addingAddonItem = null;
  });

  // Add Standalone Add-On button
  $(document).ready(function() {
    var packageItemsField = acf.getField('field_5c6c1967d0e0d');
    var $addRowActions = packageItemsField.$actions();
    if($addRowActions.length) {
      $addRowActions.append(' <a class="acf-button button button-primary add-standalone-addon-btn" href="#">Add Standalone Add-On</a>');
    }
  });

  $body.on('click', '.add-standalone-addon-btn', function (e) {
    e.preventDefault();
    addingAddonItem = { standalone: true };
    var packageItemsField = acf.getField('field_5c6c1967d0e0d');
    packageItemsField.add();
    addingAddonItem = null;
  });
}
